import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import BranchGateway from '~apis/branch';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TEditRegionDetailsReduxParams } from '~types/feat/branch';

export default function* watchEditRegionDetails(api: BranchGateway): SagaWatcherReturnType {
    yield takeEvery('branch/branchEditRegionDetailsAttempt', handleEditRegionDetails, api);
}

function* handleEditRegionDetails(api: BranchGateway, action: PayloadAction<TEditRegionDetailsReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const isEditing = reduxState.branch.modals.regionIsEditing;
    const {
        regionId,
        regionName,
        status,
    } = action.payload;

    if (!regionId || !regionId || !regionName) {
        yield put(combinedActions.branchEditRegionDetailsFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    const response = yield* call([api, api.editRegionDetails], {
        authToken,
        regionId,
        regionName,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.branchEditRegionDetailsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {

        if (isEditing) {
            yield put(combinedActions.branchSetRegionDetailsModalIsEditing(false));
            yield put(combinedActions.branchSetRegionDetailsModalIsOpen(false));
        } else {
            yield put(combinedActions.branchSetDeleteRegionModalIsOpen(false));
        }

        yield put(combinedActions.branchEditRegionDetailsSuccess());
        yield put(combinedActions.branchSetRegionListingIndex({ index: 0 }));
        yield put(combinedActions.branchGetRegionListingAttempt()); // for rendering the list in branch management
        yield put(combinedActions.branchGetAllRegionsAttempt()); // for filters (separate API to get all)

        toast.success(SuccessMessages.BranchUpdateRegionSuccess);
    }
}
